import { render, staticRenderFns } from "./GeneralTermsOfSale.vue?vue&type=template&id=80589aec&scoped=true"
import script from "./GeneralTermsOfSale.vue?vue&type=script&lang=js"
export * from "./GeneralTermsOfSale.vue?vue&type=script&lang=js"
import style0 from "./GeneralTermsOfSale.vue?vue&type=style&index=0&id=80589aec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80589aec",
  null
  
)

export default component.exports